<template>
  <b-row class="h-100">
    <b-col class="container">
      <div
        class="d-flex flex-row justify-content-between align-items-center pl-4 pr-4 pt-3"
      >
        <h5>
          {{ form ? form.name : "" }}<br />
          <span class="grid-count color-custom-dark-grey"
            >({{ list.length }} documents)</span
          >
        </h5>
        <div>
          <b-button
            v-if="
              formHasComponents &&
                hasCurrentUserDocumentPermission(form.id, 'hasEntryAccess')
            "
            variant="primary"
            class="pl-3 pr-3 pt-1 pb-1 mr-2"
            size="sm"
            @click="addSubmit"
            ><i class="fa fa-plus mr-2"></i>New</b-button
          >
          <b-button
            v-if="hasCurrentUserDocumentPermission(form?.id, 'hasEntryAccess')"
            variant="primary"
            class="pl-3 pr-3 pt-1 pb-1 mr-2"
            size="sm"
            @click="addSubmitFile"
            ><i class="fa fa-cloud-upload-alt mr-2"></i>Upload</b-button
          >
        </div>
      </div>
      <div class="px-4 mt-3 mb-0 w-100 d-flex flex-row justify-content-between">
        <div class="d-flex align-items-center" style="font-size: 19px;">
          <div>
            <a
              class="hover-pointer"
              style="font-size: 14px"
              @click="showReportRequestsModal = true"
            >
              <i class="fa fa-download"></i>
              <span class="ml-2 text-primary" style="font-size: 14px"
                >Export</span
              >
            </a>
          </div>
        </div>
        <div class="d-flex flex-row justify-content-end align-items-center">
          <top-paginator
            :total="itemsFilter.length"
            :page="paginator.page"
            :perPage="paginator.perPage"
            @change-page="changePage"
          />
        </div>
      </div>
      <div class="px-4">
        <grid
          v-if="client && eoc && form"
          class=""
          ref="grid"
          :groupFeature="false"
          :store="gridConfig.store"
          :columns="columns"
          :autoHeight="true"
          :data="items"
          :selectionMode="gridConfig.selectionMode"
          :columnLines="gridConfig.columnLines"
          :searchFeature="true"
          :stripeFeature="false"
          @storesort="listeners.storeSort"
          @renderrows="hookDropdownButtons"
          @renderrow="hookDropdownButtons"
        ></grid>
      </div>

      <document-file-add-edit-modal
        v-if="showEditor"
        v-model="showEditor"
        :formId="formId"
        :eocId="eocId"
        @onModify="onModify"
        :clientId="clientId"
        :submitId.sync="submitId"
      />
      <document-add-edit-modal
        v-if="showAddDocumentEditor"
        v-model="showAddDocumentEditor"
        :formId="formId"
        @onModify="onModifyAddDocument"
        :clientId="clientId"
        :eocId="eocId"
        :submitId="submitId"
      />
      <document-share-multiple-modal
        v-if="showSendLinkEditor"
        v-model="showSendLinkEditor"
        @onModify="onModifySendLink"
        :patientId="clientId"
        :eocId="eocId"
        :forms="selectedForms"
      />
      <document-view-modal
        v-if="showDocumentViewModal"
        v-model="showDocumentViewModal"
        :documentId="submitId"
        @onModify="onModifyAddDocument"
      />
      <report-request-index
        v-if="showReportRequestsModal"
        v-model="showReportRequestsModal"
        :reportFilters="exportFilter"
        reportName="Documents"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Grid from "../../../third_party/grid/Grid.vue";
import formSubmitterServer from "../../../server/formSubmitter";
import eocServer from "../../../server/eoc";
import patientServer from "../../../server/patient";
import {
  getElementComponentData,
  getElementFromId,
  getFormBuilderComponents
} from "../../../../../Breeze.FormBuilder.Frontend/helpers/formBuilder";
import { formatDate } from "../../../helpers/date";
import DocumentFileAddEditModal from "./DocumentFileAddEditModal.vue";
import DocumentViewModal from "./DocumentViewModal.vue";
import DocumentAddEditModal from "./DocumentAddEditModal.vue";
import DocumentShareMultipleModal from "./DocumentShareMultipleModal.vue";
import TopPaginator from "../../controls/TopPaginator.vue";
import ReportRequestIndex from "../../report_request/ReportRequestIndex.vue";

export default {
  name: "DocumentList",
  components: {
    Grid,
    TopPaginator,
    DocumentFileAddEditModal,
    DocumentShareMultipleModal,
    DocumentAddEditModal,
    ReportRequestIndex,
    DocumentViewModal
  },
  props: ["clientId", "eocId", "formId", "showing"],
  data() {
    const self = this;
    return {
      list: [],
      gridConfig: {
        minHeight: "20em",
        selectionMode: {
          row: true
        },
        columnLines: false,
        store: {
          sorters: [{ field: "createdAt", ascending: false }]
        }
      },
      paginator: {
        page: 0,
        perPage: 10
      },
      orderBy: "createdAt",
      orderByDescending: true,
      search: "",
      form: null,
      showEditor: false,
      showAddDocumentEditor: false,
      showSendLinkEditor: false,
      showDocumentViewModal: false,
      selectedForms: [],
      submitId: null,
      client: null,
      eoc: null,
      listeners: {
        storeSort: async sortData => {
          if (sortData.sorters.length == 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.orderBy = field;
            self.orderByDescending = !ascending;
            self.changePage(0);
          }
        }
      },
      showReportRequestsModal: false
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("formSubmitter", ["deleteFormSubmitterSubmit"]),
    async fetchData() {
      this.getEoc();
      this.getClient();
      this.fetchFormSubmitterSubmits();
      this.form = await this.getFormBuilderFormById(this.formId);
    },
    async getEoc() {
      this.eoc = await eocServer.get(this.eocId);
    },
    async getClient() {
      this.client = await patientServer.get(this.clientId);
    },
    refreshData() {
      this.fetchFormSubmitterSubmits();
    },
    async fetchFormSubmitterSubmits() {
      const forms = await formSubmitterServer.query(
        this.formId,
        this.clientId,
        this.eocId
      );
      this.list = forms;
    },
    addSubmit() {
      this.submitId = null;
      this.showAddDocumentEditor = true;
    },
    addSubmitFile() {
      this.submitId = null;
      this.showEditor = true;
    },
    changePage(page) {
      this.paginator.page = page;
    },
    onModify() {
      this.showEditor = false;
      this.fetchFormSubmitterSubmits();
    },
    onModifySendLink() {
      this.showSendLinkEditor = false;
    },
    onModifyAddDocument() {
      this.showAddDocumentEditor = false;
      this.fetchFormSubmitterSubmits();
    },
    exportExcel() {
      this.$refs.grid.exportExcel();
    }
  },
  computed: {
    ...mapGetters("layout", ["hasCurrentUserDocumentPermission"]),
    ...mapState("layout", {
      selectedLocation: state => state.selectedLocation,
      currentUser: state => state.currentUser
    }),
    itemsFilter() {
      let newList = this.list;
      newList.sort((a, b) => {
        let aValue = a[this.orderBy];
        let bValue = b[this.orderBy];
        if (this.orderBy && this.orderBy.includes(".")) {
          aValue = a.results[this.orderBy.split(".")[1]];
          bValue = b.results[this.orderBy.split(".")[1]];
        }
        if (!aValue) aValue = "";
        if (!bValue) bValue = "";
        return (
          aValue.toString().localeCompare(bValue.toString()) *
          (this.orderByDescending ? -1 : 1)
        );
      });
      return newList.filter(item => {
        const query = this.search.trim().toLowerCase();
        const columnsSearch = [];
        if (this.form) {
          this.form.current.content.grid.components.forEach(component => {
            const jsonElement = getElementFromId(
              this.form.current.content,
              component
            );
            if (jsonElement) {
              columnsSearch.push(item.results[component]);
            }
          });
        }
        return (
          query == "" ||
          item.status.toLowerCase().indexOf(query) >= 0 ||
          columnsSearch.filter(col => col.toLowerCase().indexOf(query) >= 0)
            .length > 0
        );
      });
    },
    items() {
      return this.itemsFilter.slice(
        this.paginator.page * this.paginator.perPage,
        (this.paginator.page + 1) * this.paginator.perPage
      );
    },
    ...mapGetters("formBuilder", ["getFormBuilderFormById"]),
    hasSubmits() {
      return this.items.filter(item => item.mode == "Results").length > 0;
    },
    columns() {
      let columns = [];
      columns.push({
        text: "Ref#",
        field: "documentRefNumber",
        width: 60,
        editor: false
      });
      columns.push({
        text: "Created at",
        field: "createdAt",
        type: "template",
        width: 180,
        editor: false,
        template: data => `${formatDate(data.record.data.createdAt)}`,
        sortable: () => {
          return this.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Created by",
        field: "createdBy",
        type: "template",
        width: 220,
        editor: false,
        template: data =>
          `${
            data.record.data.createdBy
              ? this.formatUser(data.record.data.createdBy)
              : ""
          }`,
        sortable: () => {
          return this.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Status",
        field: "status",
        type: "template",
        width: 130,
        editor: false,
        template: ({ record }) => {
          let className = "warning";
          let statusText = "Pending";
          if (record.data.status == "Completed") {
            className = "success";
            statusText = "Completed";
          }
          if (record.data.status == "Draft") {
            className = "danger";
            statusText = "Draft";
          }
          return `<span class="badge px-4 py-2 badge-${className} text-white badge-fixed-size">${statusText}</span>`;
        },
        sortable: () => {
          return this.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Effective date",
        field: "effectiveDate",
        type: "template",
        width: 180,
        editor: false,
        template: data =>
          data.record.data.effectiveDate
            ? formatDate(data.record.data.effectiveDate)
            : "",
        sortable: () => {
          return this.orderByDescending ? -1 : 1;
        }
      });

      if (this.form && this.hasSubmits) {
        this.form.current.content.grid.components.forEach(component => {
          const jsonElement = getElementFromId(
            this.form.current.content,
            component
          );
          if (jsonElement) {
            const componentData = getElementComponentData(
              jsonElement.elType,
              jsonElement.version
            );
            columns.push({
              text: jsonElement.properties.label
                ? jsonElement.properties.label
                : "",
              field: `results.${component}`,
              editor: false,
              ...componentData.gridAttrs,
              sortable: () => {
                return this.orderByDescending ? -1 : 1;
              }
            });
          }
        });
      }

      columns.push({
        text: "Type",
        field: "mode",
        type: "template",
        width: 90,
        editor: false,
        template: data =>
          `${data.record.data.mode == "File" ? "File" : "Document"}`,
        sortable: () => {
          return !this.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "File name",
        field: "fileName",
        type: "template",
        width: 180,
        editor: false,
        template: data => {
          return data.record.data.mode === "File"
            ? `${data.record.data.fileName}`
            : null;
        },
        sortable: () => {
          return !this.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Score",
        type: "template",
        flex: 1,
        template: ({ record }) => {
          return record.data.score && !isNaN(record.data.score)
            ? record.data.score
            : "";
        },
        sortable: false
      });
      columns.push({
        text: "Tools",
        type: "action",
        cellCls: "pointer-cell flex-grow-1",
        field: "action",
        align: "right",
        width: 80,
        actions: [
          {
            tooltip: "View",
            renderer: () =>
              `<i class="fa fa-search-plus color-custom-dark-grey hover-text-primary b-action-item grid-action-icon"></i>`,
            onClick: ({ record }) => {
              if (record.data.mode == "File") {
                const url = formSubmitterServer.viewUrl(record.data.id);
                window.open(url, "_blank");
              } else {
                this.submitId = record.data.id;
                this.showDocumentViewModal = true;
              }
            }
          },
          {
            tooltip: "More",
            renderer: ({ record }) => {
              if (
                !this.hasCurrentUserDocumentPermission(
                  record.data.formId,
                  "isReadOnly"
                )
              )
                return "";
              const actions = [];

              if (
                record.status == "Draft" ||
                this.hasCurrentUserDocumentPermission(
                  record.data.formId,
                  "isReadOnly"
                )
              ) {
                actions.push({
                  content: "Share Document",
                  callback: () => {
                    this.selectedForms = [
                      {
                        formId: this.form.id,
                        formVersionId: record.versionId,
                        formGroupId: null,
                        documentId: record.id,
                        documentGroupId: null,
                        status: record.status,
                        mode: record.mode
                      }
                    ];
                    this.showSendLinkEditor = true;
                  }
                });
              }

              if (
                (record.status == "Completed" &&
                  this.hasCurrentUserDocumentPermission(
                    record.data.formId,
                    "hasCompleteAccess"
                  )) ||
                (record.status != "Completed" &&
                  this.hasCurrentUserDocumentPermission(
                    record.data.formId,
                    "hasEntryAccess"
                  ))
              ) {
                actions.push({
                  content: "Edit",
                  callback: () => {
                    this.submitId = record.id;
                    if (record.mode == "File") this.showEditor = true;
                    else this.showAddDocumentEditor = true;
                  }
                });
              }

              if (
                record.status != "Completed" &&
                this.hasCurrentUserDocumentPermission(
                  record.data.formId,
                  "hasEntryAccess"
                )
              ) {
                actions.push({
                  content: "Delete",
                  callback: () => {
                    this.$dialog
                      .alert(
                        {
                          title: "Are you sure you want to delete this record?"
                        },
                        {
                          view: "confirm-delete"
                        }
                      )
                      .then(async () => {
                        const result = await this.deleteFormSubmitterSubmit({
                          submitId: record.id,
                          formId: this.formId,
                          clientId: this.clientId,
                          eocId: this.eocId
                        });
                        if (result.errorCode) {
                          this.$dialog.alert("Error: " + result.message);
                        } else {
                          this.showAlertSuccess();
                          this.fetchFormSubmitterSubmits();
                        }
                      });
                  }
                });
              }

              return this.createDropdownButton({
                items: actions
              });
            }
          }
        ]
      });
      return columns;
    },
    formHasComponents() {
      return (
        this.form &&
        getFormBuilderComponents(this.form.current.content).length > 0
      );
    },
    exportFilter() {
      return {
        eocsIds: [this.eocId],
        formIds: [this.formId],
        fromCreation: null,
        toCreation: null,
        fromEffectiveDate: null,
        toEffectiveDate: null,
        createdByIds: [],
        statuses: [],
        orderBy: this.orderBy,
        sort: this.orderByDescending ? "DESC" : "ASC",
        locationIds: [this.selectedLocation]
      };
    }
  },
  watch: {
    showing: async function(newValue) {
      if (newValue) {
        await this.fetchData();
      }
    }
  }
};
</script>

<style scoped>
.grid-count {
  font-size: 0.8rem;
}
.eoc-document-list-container >>> .b-grid-container .b-container {
  max-height: calc(100vh - 369px) !important;
  min-height: calc(100vh - 369px) !important;
}
</style>
